import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';


//------------------------------ AsyncThunk ------------------------------
export const getAddressEntries = createAsyncThunk('checkFiberInfrastructureBlock/getAddressEntries', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const state = thunkAPI.getState().checkFiberInfrastructureBlock;
    const result = await ProviderManager.getProviderData('getAddressEntries', [
      state.addressPage.selectedAddress.cityCode,
      state.addressPage.selectedAddress.streetCode,
      state.addressPage.selectedAddress.home,
    ]);
    return result;
  } catch (error) {
    return error;
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const checkFiberAddressInfraStructure = createAsyncThunk('checkFiberInfrastructureBlock/checkFiberAddressInfraStructure', async (data, thunkAPI) => {
  try {
    const state = thunkAPI.getState().checkFiberInfrastructureBlock;
    const entry = state.addressPage.selectedAddress.entry;
    let entryRequest = entry == "ללא שם" ? "NONE" : (entry == null || entry == '') ? ' ' : entry;
    const result = await ProviderManager.getProviderData('checkFiberAddressInfraStructure', [
      state.addressPage.selectedAddress.cityName,
      state.addressPage.selectedAddress.citySemel,
      state.addressPage.selectedAddress.streetName,
      state.addressPage.selectedAddress.streetSemel,
      (state.addressPage.selectedAddress.streetGisSemel ? state.addressPage.selectedAddress.streetGisSemel : '0'),
      state.addressPage.selectedAddress.home,
      entryRequest,
      state.addressPage.selectedAddress.apartment,
    ]);
    return result;
  } catch (error) {
    return error;
  }
});

export const checkWhatsAppActivity = createAsyncThunk('checkFiberInfrastructureBlock/checkWhatsAppActivity', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const isWhatsAppActive = await ProviderManager.getProviderData('getSaleWhatsAppActivity', []);
    return isWhatsAppActive;
  } catch (error) {
    return false;
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const createLead = createAsyncThunk('checkFiberInfrastructureBlock/createLead', async (data, thunkAPI) => {

  let campaignCode = '';
  let campaignName = '';
  let productId = '';
  try {
    thunkAPI.dispatch(showAppLoader());
    const state = thunkAPI.getState().checkFiberInfrastructureBlock;

    let campaignCode = state.noFiberCampaignCode;
    let campaignName = state.noFiberCampaignName;
    let productId = state.noFiberProductId;

    const recaptchaToken = '';
    const fullName = state.personalInfo.firstName + ' ' + state.personalInfo.lastName;
    const phone = state.personalInfo.subscriberNo;
    const url = encodeURI(window.location.origin + window.location.pathname);
    const bannerId = '';
    const searchTerm = '';
    const adSource = '';
    const description = '';
    const isAgreementsCheckBoxActive = false;

    const result = await ProviderManager.getProviderData('createLead', [
      recaptchaToken,
      fullName,
      phone,
      campaignCode,
      campaignName,
      productId,
      adSource,
      url,
      bannerId,
      searchTerm,
      isAgreementsCheckBoxActive,
      description
    ]);

    return result;
  } catch (error) {
    thunkAPI.dispatch(reportDWH({ actionType: 'Error', status: 'Error', messageText: 'Lead Error - campaignCode : ' + campaignCode + ', campaignName: ' + campaignName + ', productId: ' + productId }));
    return error;
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});
//------------------------------ AsyncThunk ------------------------------


const initialState = {
  addressPage: {
    selectedAddress: {},
    selectedEntry: {},
  },
  personalInfo: {
    firstName: '',
    lastName: '',
    subscriberNo: ''
  },
  isWhatsAppActive: false,
  noFiberCampaignCode: '',
  noFiberCampaignName: '',
  noFiberProductId: '',
};

const checkFiberInfrastructureSlice = createSlice({
  name: 'checkFiberInfrastructureBlock',
  initialState: initialState,
  reducers: {
    resetBlock: (state) => initialState,
    initBlock: {
      reducer: (state, action) => {
        state.noFiberCampaignCode = action.payload.noFiberCampaignCode;
        state.noFiberCampaignName = action.payload.noFiberCampaignName;
        state.noFiberProductId = action.payload.noFiberProductId;
      },
      prepare: (action) => {
        const currentBlock = action.checkFiberInfrastructureBlock;

        const payload = {
          noFiberCampaignCode: currentBlock.noFiberCampaignCode.value,
          noFiberCampaignName: currentBlock.noFiberCampaignName.value,
          noFiberProductId: currentBlock.noFiberProductId.value
        };
        return { payload: payload };
      }
    },
    setSelectedAddress: (state, action) => {
      state.addressPage.selectedAddress = action.payload;
    },
    setSelectedEntry: (state, action) => {
      state.addressPage.selectedEntry = action.payload;
      state.addressPage.selectedAddress.entry = action.payload.entry;
    },
    setPersonalInfo: (state, action) => {
      state.personalInfo = action.payload;
    },
    reportDWH: (state, action) => { },
  },
  extraReducers: {
    [checkWhatsAppActivity.fulfilled]: (state, action) => {
      state.isWhatsAppActive = action.payload?.Body;
    },
  },
});

export const {
  resetBlock,
  initBlock,
  setSelectedAddress,
  setSelectedEntry,
  setPersonalInfo,
  reportDWH
} = checkFiberInfrastructureSlice.actions;
export default checkFiberInfrastructureSlice.reducer;
